/**
 * Logo component
 */
import React from "react"
import PropTypes from "prop-types"
import { LogoLink, NoLink, ILogo } from "./styles"
import Icon from "../Icon"
import { VARIANTS } from "./constants"
import { isApplicationMode, isInternalMode } from "utils/productUtils"

export const Logo = ({
  path = false,
  variant,
  logoURL,
  logoWidth,
  logoMargin,
  large,
  leftForMobile,
}) => (
  <React.Fragment>
    {path === false ? (
      <NoLink
        to={path}
        variant={variant}
        width={logoWidth ? logoWidth : VARIANTS[variant].width}
        leftForMobile={leftForMobile}
      >
        {logoURL ? (
          <ILogo
            src={logoURL}
            logoWidth={logoWidth}
            logoMargin={logoMargin}
            large={large}
            alt={"Company logo"}
          />
        ) : (
          !isApplicationMode() && (
            <Icon
              variant={
                variant === "rareHeader"
                  ? isInternalMode()
                    ? "rare_logo_white"
                    : "rare_vantage_logo_white"
                  : "vantage_logo_lrg"
              }
            />
          )
        )}
      </NoLink>
    ) : (
      <LogoLink
        to={path}
        variant={variant}
        width={logoWidth ? logoWidth : VARIANTS[variant].width}
        leftForMobile={leftForMobile}
      >
        {logoURL ? (
          <ILogo
            src={logoURL}
            logoWidth={logoWidth}
            logoMargin={logoMargin}
            large={large}
            alt={"Company logo"}
          />
        ) : (
          !isApplicationMode() && (
            <Icon
              variant={
                variant === "rareHeader"
                  ? isInternalMode()
                    ? "rare_logo_white"
                    : "rare_vantage_logo_white"
                  : "vantage_logo_lrg"
              }
            />
          )
        )}
      </LogoLink>
    )}
  </React.Fragment>
)

export default Logo

Logo.defaultProps = {
  path: "/",
  variant: "header",
}

Logo.propTypes = {
  path: PropTypes.string,
  variant: PropTypes.string,
}
